import React from "react";
import Translate from "../../../common/functions/translate";
import Button from "@material-ui/core/Button";
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import { DropdownModel } from '../../../models/dropdownModel';
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import { PipeInstallation, OfferSteps } from '../../../common/enums';
import PlannerDialog from './plannerDialog';
import AutoCompleteWithList from './autocompleteWithList';
import { newPlannerProject2Layers } from '../../../common/constants';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import InstallationArticlesList from '../installationArticlesList';

const HeathInstallationComponent = (props: any) => {
    const [isOpen, open] = React.useState(false);
    const [isAxonometric, setAxonometric] = React.useState(false);
    const [selectedTab, setSelectedTab] = React.useState(props.heathInstall.activeTab ? props.heathInstall.activeTab : 0);
    let pipeInstallTypes = new Array<DropdownModel>(0);
    pipeInstallTypes = HelperFunctions.enumToDropdownArray(PipeInstallation, true);
    let planner = props.planner;

    let setOpen = (isAxonometric) => {
        setAxonometric(isAxonometric);
        open(true);
    }

    let toggleDialog = (isVis, isSaved) => {
        open(isVis);
        props.fullSave(isSaved);
    }

    let handleTabChange = (e: any, index: number) => {
        setSelectedTab(index);
        props.changeTab(index);
        props.resetSearechedProducts();
    }

    if (!planner)
        planner = JSON.parse(JSON.stringify(newPlannerProject2Layers));
    return <>
        <div style={{ marginBottom: 10, display: 'flex', justifyContent: 'flex-start', alignItems: "center" }}>
            <FormControl style={{ width: 300, marginRight: "10px" }}>
                <InputLabel htmlFor="pipeInstall-label">{Translate('PipeInstall')}</InputLabel>
                <Select
                    name="pipeInstall"
                    value={props.heathInstall.pipeInstall ? props.heathInstall.pipeInstall : PipeInstallation.Floor}
                    onChange={(e) => props.handlePipeInstallChange(e.target.value)}
                    style={{ marginRight: 10 }}
                    disabled={props.readOnly}
                    inputProps={{
                        id: 'pipeInstall-label'
                    }}
                >
                    {
                        pipeInstallTypes.map(m => <MenuItem key={m.value + 'pipeInstall'} value={m.value}>{m.label}</MenuItem>)
                    }
                </Select>
            </FormControl>
            <Button style={{ marginRight: "10px" }} onClick={(e) => setOpen(false)} color="primary" variant="contained" >
                {Translate('HeathInstallScheme')}
            </Button>
            {/* <Button color="primary" variant="contained" onClick={(e) => setOpen(true)}>
                {Translate('AxonometricScheme')}
            </Button> */}
        </div>
        {/* <div style={{ marginTop: 20, maxWidth: 400 }}>
            <FormControlLabel
                labelPlacement={"start"}
                style={{ display: 'flex', justifyContent: 'space-between', margin: 0 }}
                control={
                    <Switch color="primary" checked={props.heathInstall.heathInstallWork || false} onChange={(e) => props.heathInstallWorkChange(e.target.checked)} />
                }
                label={Translate("WorkAndMaterialsAndSMR")}
            />
        </div>
        {props.heathInstall.heathInstallWork ?
            <AutoCompleteWithList searchedProductsDropDown={props.searchedProductsDropDown}
                currentSelection={props.currentSelection}
                handleAutocompleteSelection={props.handleAutocompleteSelection}
                handleAutocompleteKeyUp={props.handleAutocompleteKeyUp}
                handleAddButton={props.handleAddButton}
                isGasInstall={false}
                products={props.heathInstall.additionalProducts}
                handleDelete={props.handleDeleteWorkHeathClick}
                onChangeQuantity={props.onChangeQuantity}
            />
            : null} */}
        <div style={{ marginTop: 20 }}>
            <Tabs
                value={selectedTab}
                indicatorColor="primary"
                textColor="primary"
                onChange={handleTabChange}
                variant="standard">
                <Tab label={Translate('Installation articles')} />
                <Tab label={Translate('Installation services')} />
                <Tab label={Translate('Equipment and materials')} />
            </Tabs>
            {selectedTab === 0
                ? <div style={{ marginTop: 10 }}>
                    <InstallationArticlesList
                        offer={props.offer}
                        isGasInstall={false} />
                </div>
                : null}
            {selectedTab === 1
                ? <div style={{ marginTop: 10 }}>
                    <AutoCompleteWithList searchedProductsDropDown={props.searchedProductsDropDown}
                        currentSelection={props.currentSelection}
                        handleAutocompleteSelection={props.handleAutocompleteSelection}
                        handleAutocompleteKeyUp={props.handleAutocompleteKeyUp}
                        handleAddButton={props.handleAddButton}
                        isGasInstall={false}
                        isAdditionalProducts={true}
                        products={props.heathInstall.additionalProducts.filter(p => p.addedFromPlanner === false)}
                        handleDelete={props.handleDeleteWorkHeathClick}
                        onChangeQuantity={props.onChangeQuantity}
                        readOnly={props.readOnly}
                        onChangePrice={props.onChangePrice}
                    />
                </div>
                : null}
            {selectedTab === 2
                ? <div style={{ marginTop: 10 }}>
                    <AutoCompleteWithList searchedProductsDropDown={props.searchedProductsDropDown}
                        currentSelection={props.currentSelection}
                        handleAutocompleteSelection={props.handleAutocompleteSelection}
                        handleAutocompleteKeyUp={props.handleAutocompleteKeyUp}
                        handleAddButton={props.handleAddButton}
                        isAdditionalProducts={false}
                        isGasInstall={false}
                        products={props.heathInstall.products.filter(p => p.addedFromPlanner === false)}
                        handleDelete={props.handleDeleteWorkHeathClick}
                        onChangeQuantity={props.onChangeQuantity}
                        readOnly={props.readOnly}
                    />
                </div>
                : null}

        </div>

        {isOpen ?
            <PlannerDialog
                isOpen={isOpen}
                toggle={toggleDialog}
                activeStepNumber={props.activeStepNumber}
                activeStep={props.activeStep}
                saveClick={props.saveClick}
                catalogType={OfferSteps.HeatingInstallation}
                planner={planner}
                offer={props.offer}
                copiedLayer={props.copiedLayer}
                isAxonometric={isAxonometric}
                pipeInfo={props.offer.heathInstall.pipeInfo}
            /> : null}
    </>

}

export default HeathInstallationComponent;
